import { lazy } from 'react';
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';

const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/auth/Register')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/auth/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('views/pages/authentication/auth/ResetPassword')));
const AuthCodeVerification = Loadable(lazy(() => import('views/pages/authentication/auth/CodeVerification')));
const Setup2FA = Loadable(lazy(() => import('views/pages/authentication/auth/Setup2FA')));
const Verify2FA = Loadable(lazy(() => import('views/pages/authentication/auth/Verify2FA')));

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        { path: '/login', element: <AuthLogin /> },
        { path: '/code-verification', element: <AuthCodeVerification /> },
        { path: '/register', element: <AuthRegister /> },
        { path: '/forgot-password', element: <AuthForgotPassword /> },
        { path: '/reset-password', element: <AuthResetPassword /> },
        { path: '/setup-2fa', element: <Setup2FA /> },
        { path: '/verify-2fa', element: <Verify2FA /> }
    ]
};

export default LoginRoutes;
